/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { entityMediaControllerAttach } from '../fn/file-manager-entita/entity-media-controller-attach';
import { EntityMediaControllerAttach$Params } from '../fn/file-manager-entita/entity-media-controller-attach';
import { entityMediaControllerDetach } from '../fn/file-manager-entita/entity-media-controller-detach';
import { EntityMediaControllerDetach$Params } from '../fn/file-manager-entita/entity-media-controller-detach';
import { entityMediaControllerDetachAndDelete } from '../fn/file-manager-entita/entity-media-controller-detach-and-delete';
import { EntityMediaControllerDetachAndDelete$Params } from '../fn/file-manager-entita/entity-media-controller-detach-and-delete';
import { entityMediaControllerGetEntityFiles } from '../fn/file-manager-entita/entity-media-controller-get-entity-files';
import { EntityMediaControllerGetEntityFiles$Params } from '../fn/file-manager-entita/entity-media-controller-get-entity-files';
import { entityMediaControllerUploadAndAttach } from '../fn/file-manager-entita/entity-media-controller-upload-and-attach';
import { EntityMediaControllerUploadAndAttach$Params } from '../fn/file-manager-entita/entity-media-controller-upload-and-attach';
import { EntityMediaItem } from '../models/entity-media-item';
import { EntityMediaResponse } from '../models/entity-media-response';

@Injectable({ providedIn: 'root' })
export class FileManagerEntitaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `entityMediaControllerUploadAndAttach()` */
  static readonly EntityMediaControllerUploadAndAttachPath = '/file-manager/{entity}/{entityId}/upload';

  /**
   * Carica un file e associalo direttamente a un'entità.
   *
   * Combina upload e associazione in un'unica chiamata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityMediaControllerUploadAndAttach()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  entityMediaControllerUploadAndAttach$Response(params: EntityMediaControllerUploadAndAttach$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
    const obs = entityMediaControllerUploadAndAttach(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Carica un file e associalo direttamente a un'entità.
   *
   * Combina upload e associazione in un'unica chiamata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityMediaControllerUploadAndAttach$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  entityMediaControllerUploadAndAttach(params: EntityMediaControllerUploadAndAttach$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityMediaItem;
}> {
    const resp = this.entityMediaControllerUploadAndAttach$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>): BaseResponse & {
'data'?: EntityMediaItem;
} => r.body)
    );
  }

  /** Path part for operation `entityMediaControllerAttach()` */
  static readonly EntityMediaControllerAttachPath = '/file-manager/attach';

  /**
   * Associa un file esistente a un'entità.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityMediaControllerAttach()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entityMediaControllerAttach$Response(params: EntityMediaControllerAttach$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
    const obs = entityMediaControllerAttach(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Associa un file esistente a un'entità.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityMediaControllerAttach$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  entityMediaControllerAttach(params: EntityMediaControllerAttach$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityMediaItem;
}> {
    const resp = this.entityMediaControllerAttach$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>): BaseResponse & {
'data'?: EntityMediaItem;
} => r.body)
    );
  }

  /** Path part for operation `entityMediaControllerGetEntityFiles()` */
  static readonly EntityMediaControllerGetEntityFilesPath = '/file-manager/{entity}/{entityId}';

  /**
   * Recupera tutti i file di un'entità.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityMediaControllerGetEntityFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerGetEntityFiles$Response(params: EntityMediaControllerGetEntityFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaResponse;
}>> {
    const obs = entityMediaControllerGetEntityFiles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Recupera tutti i file di un'entità.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityMediaControllerGetEntityFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerGetEntityFiles(params: EntityMediaControllerGetEntityFiles$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityMediaResponse;
}> {
    const resp = this.entityMediaControllerGetEntityFiles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaResponse;
}>): BaseResponse & {
'data'?: EntityMediaResponse;
} => r.body)
    );
  }

  /** Path part for operation `entityMediaControllerDetach()` */
  static readonly EntityMediaControllerDetachPath = '/file-manager/{entity}/{entityId}/{mediaId}';

  /**
   * Rimuovi l'associazione tra file ed entità (il file viene eliminato da db, ma non da minio).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityMediaControllerDetach()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerDetach$Response(params: EntityMediaControllerDetach$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
    const obs = entityMediaControllerDetach(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Rimuovi l'associazione tra file ed entità (il file viene eliminato da db, ma non da minio).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityMediaControllerDetach$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerDetach(params: EntityMediaControllerDetach$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityMediaItem;
}> {
    const resp = this.entityMediaControllerDetach$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>): BaseResponse & {
'data'?: EntityMediaItem;
} => r.body)
    );
  }

  /** Path part for operation `entityMediaControllerDetachAndDelete()` */
  static readonly EntityMediaControllerDetachAndDeletePath = '/file-manager/{entity}/{entityId}/{mediaId}/delete';

  /**
   * Rimuovi l'associazione tra file ed entità (il file viene eliminato da db e minio).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `entityMediaControllerDetachAndDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerDetachAndDelete$Response(params: EntityMediaControllerDetachAndDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>> {
    const obs = entityMediaControllerDetachAndDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Rimuovi l'associazione tra file ed entità (il file viene eliminato da db e minio).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `entityMediaControllerDetachAndDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  entityMediaControllerDetachAndDelete(params: EntityMediaControllerDetachAndDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EntityMediaItem;
}> {
    const resp = this.entityMediaControllerDetachAndDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EntityMediaItem;
}>): BaseResponse & {
'data'?: EntityMediaItem;
} => r.body)
    );
  }

}
